<template>
  <Select v-model="model" filterable remote clearable :label="label" @on-change="onChange"
    :remote-method="remoteMethod" :loading="loading" transfer>
    <Option v-for="student in studentList" :value="student.id" :key="student.id">
      {{ student.id }} - {{ student.nickname }}
    </Option>
  </Select>
</template>
<script>
export default {
  name: 'StudentSelect',
  props: {
    value: {
      type: [Number, String]
    },
    label: {
      type: String
    }
  },
  data () {
    return {
      studentList: [],
      loading: false,
      model: this.value
    }
  },
  methods: {
    remoteMethod (query) {
      query = query === null ? '' : query.trim()
      if (query === null || query === '') {
        this.studentList = []
        return
      }
      let self = this
      self.loading = true
      let params = { infoKeyword: query }
      self.$http.get('/user/listByCondition', { params: params }).then(function (res) {
        self.studentList = res.data
        self.loading = false
      })
    },
    onChange (value) {
      this.$emit('input', value)

      let student = this.studentList.filter(item => item.id === value)[0]
      this.$emit('change-select', student)

      if (student) {
        let name = student.id + ' ' + student.nickname
        this.$emit('on-change', value, name)
      } else {
        this.$emit('on-change', value, '')
      }
    },
  },
  mounted: function () {
  },
  watch: {
    value (val) {
      this.model = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentSelect.vue?2fd3b544